<template>
	<page enable-flex style="background: #fff;">
		<div class="head flex-between-center">
			<div class="head-date flex-center">
				<div class="head-date-button flex-center" @click="switchHandle(-1)"><i class="tf tf-angle-left"></i></div>
				<p>{{date.format('yyyy-MM')}}</p>
				<div class="head-date-button flex-center" @click="switchHandle(1)"><i class="tf tf-angle-right"></i></div>
				<a @click="switchHandle()">回到本月</a>
			</div>

			<div class="head-handle flex-center" @click="filterHandle">
				<i class="tf">&#xe67f;</i>
				<span v-if="effectFilterCount > 0">{{effectFilterCount}}</span>
			</div>
		</div>

		<div ref="schedule" class="body flex-grow flex">
			<dl class="staff">
				<dt class="flex-start-center">全部售后工程师</dt>
				<dd>
					<ul>
						<li v-for="(item, i) in staffList" :key="i" :style="{'height': Math.max(item.timeline.length * 0.9 - 0.1 + 0.4, 1.2) + 'rem'}">
							<div class="person flex-center">
								<member-icon :icon="item.head_photo" :name="item.user_realname" circle></member-icon>
								<div class="flex-grow">
									<p class="person-info ellipsis">{{item.user_realname}}</p>
									<p class="person-outlet ellipsis">{{item.outlet_name}}</p>
								</div>
							</div>
						</li>
					</ul>
				</dd>
			</dl>
			<div class="schedule flex-grow-auto">
				<ul class="schedule-day flex">
					<li v-for="(item, i) in dayList" :key="i" :ref="item.today ? 'today' : ''" class="flex-grow flex-column flex-center" :class="{'z-today': item.today}">
						<p>{{item.$day.getDate()}}日</p>
						<span>{{weeksName[item.$day.getDay()]}}</span>
						<div class="tag flex-column flex-end">
							<ins v-if="item.holiday_type == 1" style="color:#FF5555; background: #FBE9E9;">休</ins>
							<ins v-else-if="item.holiday_type == 2" style="color:#0764F5; background: #E1EBF9;">班</ins>
							<ins v-else-if="item.holiday_type != 0" style="color:#FF5555; background: #FBE9E9;">休</ins>
							<ins v-if="item.today" style="color: #fff; background: #f55;">今</ins>
						</div>
					</li>
				</ul>
				<div>
					<div v-for="(staff, i) in staffList" :key="i" class="schedule-row">
						<ul class="schedule-row-cell flex" :style="{'height': Math.max(staff.timeline.length * 0.9 - 0.1 + 0.4, 1.2) + 'rem'}">
							<li v-for="(item, j) in dayList" :key="j" class="flex-grow flex-center" :class="{'z-today': item.today, 'z-warn': staff.leave_application_list.includes(item.date), 'z-pause': staff.pause_application_list.includes(item.date), 'z-support': getSupportDates(staff).includes(item.date)}" :data-outlet="getSupportOutlet(staff, item.date)"></li>
						</ul>
						<div class="schedule-row-timeline">
							<ul v-for="(line, i) in staff.timeline" :key="i">
								<li v-for="(order, j) in line" :key="j"
									:ref="order.id"
									class="order-bar flex-column flex-center-start"
									:class="{'z-confirm': order.member_status == 6, 'z-wait': order.member_status == 2, 'z-finish': order.member_status == 5, 'z-before': order.position.before, 'z-after': order.position.after}"
									:style="{'left': order.position.left + 'rem', 'width': order.position.width + 'rem'}"
								>
									<p class="ellipsis">
										<i v-if="order.urgency_level == 3" class="tf">&#xe657;</i>
										<b><c-state dict="serviceTypeDic" :value="order.service_type" :color="false"></c-state> ({{order.customer_city_name}})</b>
									</p>
									<p class="ellipsis"><i class="tf">&#xe67c;</i>{{order.customer_name}}</p>
									<div class="order-bar-tag flex">
										<ins v-if="order.is_charge == 2" class="order-bar-charge" style="color: #fff; background: #FF5555;">主</ins>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<ul class="legend flex-center">
			<li class="flex-center">
				<ins style="background: #777;"></ins>
				<span>待确认</span>
			</li>
			<li class="flex-center">
				<ins style="background: #0764F5;"></ins>
				<span>待服务</span>
			</li>
			<li class="flex-center">
				<ins style="background: #02A2E9;"></ins>
				<span>服务中</span>
			</li>
			<li class="flex-center">
				<ins style="background: #00ACA9;"></ins>
				<span>已完工</span>
			</li>
		</ul>

		<c-dialog ref="filter" position="right" title="筛选" width="94%" mask-close>
			<c-form ref="filterForm">
				<c-form-item label="工程师">
					<c-select ref="userSelect" name="user_ids" placeholder="请选择" async multiple @search="searchUser"></c-select>
				</c-form-item>
				<c-form-item label="售后网点">
					<c-select ref="outletSelect" name="outlet_id" placeholder="请选择" async @search="searchOutlet"></c-select>
				</c-form-item>
			</c-form>

			<template #button>
				<c-button size="dialog" @click="$refs.filterForm.clear()">重置</c-button>
				<c-button size="dialog" color="main" @click="updateData(true)">确定</c-button>
			</template>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				filterParam: {},
				staffList: [],

				weeksName: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
				date: new Date(),
				dayList: []
			}
		},

		computed: {
			effectFilterCount() {
				return Object.keys(this.filterParam).filter(key => {
					if (Array.isArray(this.filterParam[key])) {
						return this.filterParam[key].length;
					} else {
						return this.filterParam[key].toString().trim();
					}
				}).length;
			}
		},

		mounted() {
			this.updateData();
		},
		
		methods: {
			switchHandle(type) {
				if (!type) {
					this.date = new Date();
				} else {
					this.date = new Date(this.date.getFullYear(), this.date.getMonth() + type, 1);
				}
				this.updateData();
			},

			filterHandle() {
				this.$refs.filterForm.clear();
				if (this._filterData) {
					this.$refs.userSelect.setValueData(this._filterData.user);
					this.$refs.outletSelect.setValueData(this._filterData.outlet);
				}
				this.$refs.filter.open();
			},
			
            searchUser(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        is_engineer: 1,
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			searchOutlet(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_OUTLET',
						keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.outlet_name,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			//获取支援日期列表
			getSupportDates(staff) {
				return staff.temp_support_list || staff.temp_support_set || [];
			},
			//获取指定日期的支援网点名称（只取前两个字）
			getSupportOutlet(staff, date) {
				if (!staff.support_period_list || !date) return '';
				const period = staff.support_period_list.find(p => {
					return date >= p.start_time && date <= p.end_time;
				});
				return period ? ('支援' + period.outlet_name.substring(0, 2)) : '';
			},

			updateData(filter) {
				if (filter) {
					this.filterParam = this.$refs.filterForm.get();
					this._filterData = {
						user: this.$refs.userSelect.getData(),
						outlet: this.filterParam.outlet_id ? [this.$refs.outletSelect.getData()] : []
					}
					this.$refs.filter.close();
				}
				this._lastRequest && this._lastRequest.abort();
				this._lastRequest = this.request({
					url: '/after/sale/order/schedule/list',
					data: Object.assign({
						month: this.date.format('yyyy-MM')
					}, this.filterParam),
					success: ({date_list, user_list}) => {
						this.dayList = date_list.map(item => {
							item.$day = new Date(item.date);
							item.today = item.$day.format('yyyy-MM-dd') == new Date().format('yyyy-MM-dd');
							return item;
						});

						this.$nextTick(() => {
							let $today = this.$refs.today[0];
							if ($today) {
								this.$refs.schedule.scrollLeft = $today.offsetLeft;
							} else {
								this.$refs.schedule.scrollLeft = 0;
							}
						});

						this.staffList = user_list.map(staff => {
							staff.timeline = [];
							staff.order_list.forEach(order => {
								let orderStart = new Date(order.start_time), orderEnd = new Date(order.end_time);
								let before = orderStart.format() < this.dayList[0].$day.format(),
									after = orderEnd.format() > this.dayList[this.dayList.length - 1].$day.format();
								let start = before ? this.dayList[0].$day : orderStart,
									end = after ? this.dayList[this.dayList.length - 1].$day : new Date(order.end_time);
								order.position = {
									left: start.getDate() * 1.6 - 1.6 + (before ? 0 : 0.12),
									width: (end.getDate() - start.getDate() + 1) * 1.6 - (before ? 0 : 0.12) - (after ? 0 : 0.12),
									before,
									after
								}

								let col = 0;
								while (true) {
									if (!staff.timeline[col]) {
										this.$set(staff.timeline, col, []);
									}
									
									let i;
									for (i = 0; staff.timeline[i]; i++) {
										if (!staff.timeline[i].find(temp => {
											return (order.start_time >= temp.start_time && order.start_time <= temp.end_time) ||
												(order.end_time >= temp.start_time && order.end_time <= temp.end_time) ||
												(order.start_time < temp.start_time && order.end_time > temp.end_time)
										})) {
											staff.timeline[i].push(order);
											break;
										}
									}
									
									if (i >= staff.timeline.length) {
										col++;
									} else {
										break;
									}
								}
							})
							return staff;
						})
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.head {
		position: relative;
		height: 1.1rem;
		border-bottom: .01rem solid #ddd;
		padding: 0 .2rem;
		background: #fff;

		&-date {
			gap: 10px;

			&-button {
				box-sizing: border-box;
				width: .56rem;
				height: .56rem;
				border-radius: .08rem;
				border: .01rem solid #ddd;
				font-size: .26rem;
			}

			p {
				font-size: .36rem;
				font-weight: bold;
			}

			a {
				font-size: .26rem;
				color: #666;
			}
		}

		&-handle {
			position: relative;
			width: .6rem;
			height: .6rem;
			font-size: .4rem;
			color: #333;

			span {
				position: absolute;
				right: 0;
				top: 0;
				box-sizing: border-box;
				min-width: .28rem;
				padding: 0 .06rem;
				border-radius: .14rem;
				line-height: .28rem;
				font-size: .2rem;
				text-align: center;
				color: #fff;
				background: #FFA82B;
			}
		}
	}

	.body {
		width: 100%;
		overflow: auto;
		overscroll-behavior: none;
	}

	.staff {
		align-self: flex-start;
		z-index: 10;
		position: sticky;
		left: 0;
		box-sizing: border-box;
		min-width: 2.5rem;
		border-right: 1px solid #eee;
		background: #fff;
		box-shadow: 0 -.06rem .1rem 0 rgba(0,0,0,.2);

		dt {
			z-index: 10;
			position: sticky;
			top: 0;
			box-sizing: border-box;
			height: 1rem;
			border-bottom: 1px solid #ddd;
			padding: 0 .2rem;
			font-size: .28rem;
			background: #FAFAFA;
		}

		dd {
			li {
				border-bottom: 1px solid #eee;

				.person {
					gap: .14rem;
					position: relative;
					height: 1.2rem;
					padding: 0 .1rem 0 .16rem;

					&-info {
						margin: .08rem 0 .16rem;
						font-size: .26rem;
					}

					&-outlet {
						font-size: .24rem;
						color: #999;
					}
				}
			}
		}
	}

	.schedule {
		align-self: flex-start;
		position: relative;

		&-day {
			z-index: 9;
			position: sticky;
			top: 0;

			li {
				gap: .16rem;
				position: relative;
				box-sizing: border-box;
				min-width: 1.6rem;
				height: 1rem;
				border-bottom: 1px solid #ddd;
				border-right: 1px solid #ddd;
				font-size: .28rem;
				background: #FAFAFA;

				&.z-today {
					border-right: 1px dashed #f55;
				}

				span {
					font-size: .24rem;
					color: #999;
				}

				.tag {
					position: absolute;
					right: 0;
					top: 0;

					ins {
						display: block;
						box-sizing: border-box;
						min-width: .36rem;
						padding: 0 .06rem;
						line-height: .36rem;
						font-size: .22rem;
						text-align: center;
					}
				}
			}
		}

		&-row {
			position: relative;
			border-bottom: 1px solid #eee;

			&-cell {
				background: #F7FDFF;

				li {
					position: relative;
					box-sizing: border-box;
					min-width: 1.6rem;
					border-right: 1px solid #eee;

					&.z-today {
						border-right: 1px dashed #f55;
					}

					&.z-warn {
						background: #FFF8AF;

						&:before {
							content: '请假';
							position: absolute;
							left: .04rem;
							top: .04rem;
							font-size: .22rem;
							color: #FF6900;
						}

						+ .z-warn:before {
							content: '';
						}
					}

					&.z-pause {
						background: #FFF8AF;

						&:before {
							content: '暂停接单';
							position: absolute;
							left: .04rem;
							top: .04rem;
							font-size: .22rem;
							color: #FF6900;
						}

						+ .z-pause:before {
							content: '';
						}
					}

					&.z-support {
						background: #EDF4FF;

						&:before {
							content: attr(data-outlet);
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							font-size: .24rem;
							color: rgba(150, 180, 210, 0.5);
							pointer-events: none;
							white-space: nowrap;
						}

						+ .z-support:before {
							content: '';
						}
					}
				}
			}

			&-timeline {
				position: absolute;
				inset: 0;
				box-sizing: border-box;
				padding: .2rem 0;

				ul {
					position: relative;
					height: .8rem;

					&:nth-child(n+2) {
						margin-top: .1rem;
					}
				}
			}
		}
	}
	
	.order-bar {
		gap: .08rem;
		position: absolute;
		top: 0;
		box-sizing: border-box;
		height: .8rem;
		border: .04rem solid #00A1E9;
		border-radius: .08rem;
		padding: 0 .14rem;
		background: #fff;
		user-select: none;

		&.z-before {
			border-start-start-radius: 0;
			border-end-start-radius: 0;
		}

		&.z-after {
			border-start-end-radius: 0;
			border-end-end-radius: 0;
		}

		&.z-confirm {
			border-color: #777;
			background: #777;
		}

		&.z-wait {
			border-color: #0764F5;
			background: #0764F5;
		}

		&.z-finish {
			border-color: #00ACA9;
			background: #00ACA9;
		}

		&-tag {
			position: absolute;
			right: -.04rem;
			top: -.04rem;
			border-radius: 0 .08rem 0 0;
			overflow: hidden;

			ins {
				width: .36rem;
				line-height: .36rem;
				font-size: .24rem;
				text-align: center;
			}
		}

		p {
			width: 100%;
			font-size: .24rem;
			color: #666;

			^[-1].z-confirm ^[-1..-1] {
				color: #fff;

				&:nth-child(1) {
					color: #fff;
				}
			}

			^[-1].z-wait ^[-1..-1] {
				color: #fff;

				&:nth-child(1) {
					color: #fff;
				}
			}

			^[-1].z-finish ^[-1..-1] {
				color: #fff;

				&:nth-child(1) {
					color: #fff;
				}
			}

			.tf {
				margin-right: .1rem;
			}

			&:nth-child(1) {
				color: #00A1E9;
			}
		}
	}

	.legend {
		gap: .16rem;
		z-index: 90;
		position: relative;
		height: .6rem;
		border-top: .01rem solid #eee;
		margin-top: -.01rem;

		li {
			gap: .08rem;
			font-size: .24rem;
			color: #666;

			ins {
				width: .24rem;
				height: .24rem;
			}
		}
	}
</style>